import React from 'react'
import { useTypewriter, Cursor } from "react-simple-typewriter";
import { FaFacebookF, /*FaThreds,*/ FaLinkedinIn, FaInstagram, FaWhatsapp /*FaReact*/ } from "react-icons/fa";
// import { SiTailwindcss, SiFigma, SiNextdotjs } from "react-icons/si";ccccc                            

const LeftBanner = () => {
    const [text] = useTypewriter({
      words: ["2nd Dan Black Belt in KIO.","Expert in Self-Defense techniques.", "National Gold Medalist.", "Expert in weapons like BO/Nunchaku."],
      loop: true,
      typeSpeed: 40,
      deleteSpeed: 10,
      delaySpeed: 3000,
    });
  return (
    <div className="w-full lgl:w-1/2 flex flex-col gap-20">
      <div className="flex flex-col gap-5">
        <h4 className=" text-lg font-normal">WELCOME TO KARATE GURU</h4>
        <h1 className="text-6xl font-bold text-white">
          Hi, I'm <span className="text-designColor capitalize">Sensei Sultan</span>
        </h1>
        <h2 className="text-4xl font-bold text-white">
          A <span>{text}</span>
          <Cursor
            cursorBlinking="false"
            cursorStyle="|"
            cursorColor="#ff014f"
          />
        </h2>
        <>
        <p className="text-base font-bodyFont leading-6 tracking-wide">
        Welcome to Sensei Sultan's Karate Dojo, where expertise meets tradition. With years of dedicated teaching, 
        Sensei Sultan imparts the art of karate, fostering discipline and self-defense. Join our community for expert 
        guidance, tailored programs, and a journey toward martial excellence. 
        Embrace the spirit of karate – enroll today.
        </p>
        </>
      </div>
      <div className="flex flex-col xl:flex-row gap-6 lgl:gap-0 justify-between">
        <div>
          <h2 className="text-base uppercase font-titleFont mb-4">
          Find More About Karate Guru
          </h2>
          <div className="flex gap-4">
            {/* <span className="bannerIcon" href="https://www.facebook.com/YourFacebookPage" target="_blank">
              <FaFacebookF />
            </span>
            <span className="bannerIcon">
              <FaTwitter />
            </span>
            <span className="bannerIcon">
              <FaLinkedinIn />
            </span> */}
                  <a href="https://www.facebook.com/SenseiSultan" target="_blank" rel="noopener noreferrer">
                  <span class="bannerIcon">
                  <FaFacebookF/>
                  </span>
                  </a>
                  <a href="https://www.instagram.com/sultankarateguru" target="_blank" rel="noopener noreferrer">
                  <span className="bannerIcon">
                    <FaInstagram />
                  </span>
                  </a>
                  <a href="https://www.threads.net/@sultankarateguru" target="_blank" rel="noopener noreferrer">
                  <span className="bannerIcon">
                    {/* <FaThreds /> */}
                  </span>
                  </a>
                  <a href="https://wa.me/+918105709544" target="_blank" rel="noopener noreferrer">
                  <span className="bannerIcon">
                    <FaWhatsapp />
                  </span>
                  </a>
                  <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer">
                  <span className="bannerIcon">
                    <FaLinkedinIn />
                  </span>
                  </a>
          </div>
        </div>
        {/* <div>
          <h2 className="text-base uppercase font-titleFont mb-4">
            BEST SKILL ON
          </h2>
          <div className="flex gap-4">
            <span className="bannerIcon">
              <FaReact />
            </span>
            <span className="bannerIcon">
              <SiNextdotjs />
            </span>
            <span className="bannerIcon">
              <SiTailwindcss />
            </span>
            <span className="bannerIcon">
              <SiFigma />
            </span>
          </div> 
  </div>*/}
      </div>
    </div>
  );
}

export default LeftBanner